// extracted by mini-css-extract-plugin
export default {"container":"bussiness_container__5rNFp","wrapper":"bussiness_wrapper__0cEH7","divide":"bussiness_divide__JCc66","image":"bussiness_image__sYE1g","content":"bussiness_content__ZZJJQ"};